/* eslint-disable react/prop-types */
import React from 'react';
import { Modal, Button } from 'antd';

function ImagePreview({ visible, imageSrc, onClose }) {
  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={onClose}
      centered
      title="Image Preview"
    >
      <img src={imageSrc} alt="Preview" style={{ width: '100%' }} />
      <Button onClick={onClose} style={{ marginTop: 10 }}>
        Close
      </Button>
    </Modal>
  );
};

export default ImagePreview;
